<template>
  <div id="index">
    <mNav></mNav>
    <mBanner></mBanner>

    <div class="introduce">
      <div class="intro-container">
        <div class="common-title">企业简介</div>
        <div class="intro-img">
          <img src="@/assets/imgs/introimg.png" alt="" />
        </div>
        <div class="intro-text">
          洋宇集团以自营品牌为主，集皮鞋、皮具、儿童用品的设计
          、开发、生产和销售为一体的时尚鞋服企业。公司非常重视产品的开发设计，致力于打造引领时尚和科技的一流产品。公司在温州、上海、广州、成都分别设有研发机构。
        </div>
        <div class="intro-more">
          <a href=""> <img src="@/assets/imgs/more.png" alt="more" /></a>
        </div>
      </div>
    </div>

    <div class="product">
      <div class="product-container">
        <div class="common-title">产品展示</div>
        <div class="product-list">
          <div class="item" v-for="item in collects" :key="item.title">
            <a href="">
              <img :src="item.img" alt="" />
              <div class="item-info">
                <div class="item-title">{{item.title}}</div>
                <div class="item-text">{{item.summary}}</div>
              </div>
            </a>
          </div>
          <!-- <div class="more">
            <a href="">
              <img src="@/assets/imgs/more.png" alt="" />
            </a>
          </div> -->
        </div>
      </div>
    </div>
    <div class="news">
      <div class="news-container">
        <div class="common-title">企业新闻</div>
        <div class="news-list">
          <div class="item" v-for="item in newslist" :key="item.id">
            <a :href="'/#/m/detail/'+item.id">
              <div class="item-container">
                <img :src="item.image" alt="" />
                <div class="news-content">
                  <div class="news-content-container">
                    <div class="news-date">
                      <div class="year">{{item.year}}</div>
                      <div class="date">{{item.day}}</div>
                    </div>
                    <div class="news-content-main">
                      <div class="news-title">
                        {{item.newsname}}
                      </div>
                      <div class="news-text">
                        {{item.summary}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="more">
          <a href="/#/m/news">
            <img src="@/assets/imgs/more.png" alt="" />
          </a>
        </div>
      </div>
    </div>
    <mFooter></mFooter>
  </div>
</template>
    <script>
import mNav from "@/components/m/Nav";
import mBanner from "@/components/m/Banner";
import mFooter from "@/components/m/Footer";
export default {
  name: "mIndex",
  components: {
    mNav,
    mBanner,
    mFooter,
  },
  metaInfo: {
    title: "洋宇集团",
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=yes",
      },
    ],
  },
  data() {
    return {
      collects: [
        {
          title: "商务休闲",
          summary: "2020秋 男士商务出行复古工装鞋",
          detail:
            "采用先进工艺，将商务风发挥到极致。同时为舒适型提供保障，享受一天的工作。",
          img: require("../../assets/imgs/b2.jpg"),
        },
        {
          title: "洋宇定制",
          summary: "定制系列，每一双都是独一无二",
          detail:
            "洋宇集团匠人定制系列，每一双鞋都秉承洋宇文化，在细节处彰显设计，拥有独一无二私人定制。",
          img: require("../../assets/imgs/b3.jpg"),
        },
        {
          title: "正装系列",
          summary: "与正装最完美的搭配",
          detail: "将鞋与正装完美的搭配，展现最精细的设计与最完美的匹配。",
          img: require("../../assets/imgs/b4.jpg"),
        },
      ],
      newslist:[],
    }
  },
  mounted(){
    this.getData()
  },
  methods:{
    getData() {
      this.axios
        .get(this.$host + "/api/news/list")
        .then((res) => {
          this.newslist = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
};
</script>
  <style scoped>
.introduce {
  background: #f3f3f3;
}

.intro-container {
  padding: 0 0.16rem 0.21rem 0.16rem;
}

.common-title {
  position: relative;
  padding: 0.26rem 0;
  text-align: center;
  font-size: 0.18rem;
  font-weight: 600;
  color: #000000;
  line-height: 0.31rem;
}
.common-title::after {
  position: absolute;
  left: calc(50% - 0.15rem);
  top: 0.57rem;
  content: "";
  width: 0.26rem;
  height: 0.02rem;
  background-color: #ff0000;
}

.introduce .intro-img,
.introduce .intro-img img {
  width: 100%;
}

.introduce .intro-text {
  padding: 0.18rem 0 0.25rem 0;
  font-size: 0.13rem;
  font-weight: 400;
  color: #333333;
  line-height: 0.19rem;
}

.introduce .intro-more {
  text-align: center;
}

.product-container {
  padding: 0 0.36rem 0.21rem 0.36rem;
}

.product .product-list {
  width: 100%;
}

.product .product-list .item {
  width: 100%;
  margin-top: 0.16rem;
}

.product .product-list .item a {
  width: 100%;
  height: 2.5rem;
}

.product .product-list .item a img {
  width: 100%;
  height: 1.6rem;
}

.product .product-list .item a .item-info {
  align-items: center;
  width: calc(100% - 0.04rem);
  height: 0.84rem;
  text-align: center;
  border: 0.02rem solid #eee;
  border-top: none;
}

.product .product-list .item a .item-info .item-title {
  padding-top: 0.18rem;
  font-size: 0.18rem;
  font-weight: 600;
  color: #333333;
}

.product .product-list .item a .item-info .item-text {
  font-size: 0.14rem;
  font-weight: 400;
  color: #666666;
}

.product .more {
  text-align: center;
  margin-top: 0.16rem;
}

.news {
  width: 100%;
}

.news-container {
  padding: 0 0.15rem 0.2rem 0.15rem;
}

.news .news-list {
  width: 100%;
}

.news .news-list .item {
  width: 100%;
  height: 2.45rem;
  margin-top: 0.1rem;
  background-color: #f7f7f7;
}

.news .news-list .item a {
  display: block;
  width: 100%;
  height: 100%;
}

.news .news-list .item a .item-container {
  padding: 0.1rem 0.1rem 0.14rem 0.1rem;
}

.news .news-list .item a img {
  width: 100%;
  height: 1.6rem;
}

.news .news-list .item .news-content {
  width: 100%;
  height: 0.75rem;
}

.news .news-list .item .news-content .news-content-container {
  padding: 0.14rem 0;
  display: flex;
  justify-content: space-between;
}

.news .news-list .item .news-content .news-date {
  width: 0.4rem;
}

.news .news-list .item .news-content .news-date .year {
  font-size: 0.19rem;
  font-family: Arial;
  font-weight: bold;
  color: #333333;
  border-bottom: 0.01rem solid #333333;
}

.news .news-list .item .news-content .news-date .date {
  width: 100%;
  text-align: center;
  font-size: 0.11rem;
  font-weight: 400;
  color: #666666;
}

.news .news-list .item .news-content .news-content-main {
  width: calc(100% - 0.5rem);
}

.news .news-list .item .news-content .news-content-main .news-title {
  height: 0.42rem;
  overflow: hidden;
  font-size: 0.18rem;
  font-weight: 600;
  color: #333333;
  line-height: 0.22rem;
}

.news .news-list .item .news-content .news-content-main .news-text {
  display:none;
  margin-top: 0.07rem;
  height: 0.26rem;
  overflow: hidden;
  font-size: 0.18rem;
  font-weight: 400;
  color: #999999;
  line-height: 0.18rem;
}

.news .more {
  text-align: center;
  margin-top: 0.16rem;
}
</style>


// WEBPACK FOOTER //
// src/page/m/Index.vue